import { TypePartialRackItem } from "@components/Pages/Locations/LocationRow/LocationMore/RackTable/Rack/Rack.props";

export enum ActionTypesActiveRackItem {
  SET_ACTIVE_RACK_ITEM = "SET_ACTIVE_RACK_ITEM",
}

export interface ActionActiveRackItem {
  readonly type: ActionTypesActiveRackItem;
}

export interface ActionSetActiveRackItem extends ActionActiveRackItem {
  payload?: TypePartialRackItem;
}
